module.exports = __webpack_public_path__ + "img/Villager64_ua.7416c720.webp";